import type { ReactNode } from 'react';
import { Box, InputLabel } from '@mui/material';

type RichTextEditorFrameProps = {
  label?: ReactNode;
  labelId?: string;
  readOnly?: boolean;
  toolbar?: ReactNode;
  children: ReactNode;
};

export const RichTextEditorFrame = ({
  label,
  labelId,
  readOnly = false,
  toolbar,
  children,
}: RichTextEditorFrameProps) => (
  <Box
    sx={{
      position: 'relative',
      border: 1,
      borderColor: (theme) =>
        theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
      borderRadius: 1,
      backgroundColor: 'background.paper',
      overflow: 'visible',
      transition: (theme) =>
        theme.transitions.create(['border-color', 'box-shadow'], {
          duration: theme.transitions.duration.short,
        }),
      '&:hover': {
        borderColor: readOnly
          ? (theme) =>
              theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)'
          : 'text.primary',
      },
      '&:focus-within': {
        borderColor: readOnly ? 'divider' : 'primary.main',
        boxShadow: readOnly ? 'none' : (theme) => `0 0 0 1px ${theme.palette.primary.main}`,
        '& .MuiInputLabel-root': {
          color: readOnly ? 'text.secondary' : 'primary.main',
        },
      },
    }}
  >
    {label && (
      <InputLabel
        id={labelId}
        shrink
        variant="outlined"
        sx={{
          position: 'absolute',
          top: 0,
          left: 10,
          zIndex: 1,
          px: 0.5,
          transform: 'translateY(-50%) scale(0.75)',
          transformOrigin: 'left center',
          backgroundColor: 'background.paper',
          color: readOnly ? 'text.secondary' : undefined,
        }}
      >
        {label}
      </InputLabel>
    )}
    {toolbar}
    {children}
  </Box>
);
